import { render, staticRenderFns } from "./RegistrationsHeader.vue?vue&type=template&id=71cd7e46"
import script from "./RegistrationsHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationsHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports